import { call, select, put, takeLatest } from 'redux-saga/effects';
import JSEncrypt from 'jsencrypt';
import { filterXSS } from 'xss';
import { COUNTRY_TO_CURRENCY } from '../../utils/constants';
import * as actions from '../../actions';
import submitReimbursementRequest from './api';
import { SUBMIT_REIMBURSEMENT_REQUEST } from '../../types';

export function* submitReimbursementRequestSaga({ payload: { userFiles } }) {
  try {
    const {
      root: {
        reimbursementForm: { demographicInfo, payorInfo },
      },
      Data: {
        locale,
        csrfToken,
        reimbursementDetails: { publicKey },
      },
    } = yield select();
    const { countryCode, reimbursementAmount } = demographicInfo;
    const currencyCode = demographicInfo && COUNTRY_TO_CURRENCY[countryCode];

    const userDetails = {
      locale,
      ...demographicInfo,
      reimbursementAmount: reimbursementAmount || '',
      country: countryCode,
      currencyCode,
    };
    const parsedPublicKey = publicKey && publicKey.replace(/\\n/g, '\n');
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(parsedPublicKey);

    const formData = new FormData();
    const userFilesKeys = Object.keys(userFiles);
    userFilesKeys.forEach(fileKey => formData.append('files', userFiles[fileKey]));
    Object.keys(userDetails).forEach(key => formData.append(`${key}`, userDetails[key] ?? ''));
    if (countryCode !== 'US' && countryCode !== 'CA') {
      Object.keys(payorInfo).forEach(key => {
        const payorRecord = payorInfo[key];
        if (payorRecord !== '') {
          const sanitizedInput = filterXSS(payorRecord);
          const encrypted = encrypt.encrypt(sanitizedInput);
          formData.append(`${key}`, encrypted);
        }
      });
    }

    const { data: response } = yield call(submitReimbursementRequest, csrfToken, formData, locale);

    if (!response || !response.success) {
      yield put(actions.submitReimbursementFailure());
    } else {
      yield put(actions.submitReimbursementSuccess());
    }
  } catch (e) {
    yield put(actions.submitReimbursementFailure());
  }
}

const reimbursementSagas = [
  takeLatest(SUBMIT_REIMBURSEMENT_REQUEST, submitReimbursementRequestSaga),
];

export default reimbursementSagas;
